export default __webpack_public_path__ + "e44ff1a3689056533530010f62447aec.png";